<template>
    <div class="independent-file-uploader">
      <div
        class="drop-zone"
        :class="{ 'is-dragging': isDragging, 'has-file': !!selectedFile || !!uploadedFileName, 'has-error': !!uploadError }"
        @dragover.prevent="handleDragOver"
        @dragleave.prevent="handleDragLeave"
        @drop.prevent="handleDrop"
        @click="triggerFileInput"
        role="button"
        tabindex="0"
        @keypress.enter="triggerFileInput"
        :aria-disabled="isUploading || !!uploadedFileName"
      >
        <input
          ref="fileInput"
          type="file"
           
          @change="handleFileChange"
          
          style="display: none;"
        />
  
        <div v-if="!selectedFile && !uploadedFileName && !isUploading && !uploadError" class="drop-zone-instructions">
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="feather feather-upload-cloud"><path d="M16 16l-4-4-4 4M12 12v9"></path><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><path d="M16 16l-4-4-4 4"></path></svg>
          <p>{{ dropZoneText }}</p>
          <span class="browse-link">o busca en tu equipo</span>
        </div>
  
        <div v-if="isUploading" class="status-message uploading-message">
          <div class="spinner"></div>
          <p>Subiendo {{ selectedFile ? `"${selectedFile.name}"` : 'archivo' }}...</p>
        </div>
  
        <div v-if="uploadedFileName && !uploadError" class="status-message success-message">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-check-circle"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
          <p>¡Listo! "{{ successFileName }}" cargado.</p>
          <small>(ID: {{ uploadedFileName }})</small>
        </div>
  
         <div v-if="selectedFile && !uploadedFileName && !isUploading && !uploadError" class="status-message file-info">
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-file-text"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
           <p>Archivo seleccionado:</p>
           <strong>{{ selectedFile.name }}</strong>
           <small>({{ formatFileSize(selectedFile.size) }})</small>
           </div>
  
        <div v-if="uploadError && !isUploading" class="status-message error-message">
           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-alert-triangle"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
          <p>Error al cargar:</p>
          <small>{{ uploadError }}</small>
        </div>
      </div>
  
      <button
        v-if="selectedFile || uploadedFileName || uploadError"
        @click="()=>resetState(true)"
        class="reset-button"
        :disabled="isUploading"
        title="Limpiar selección"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        Limpiar
      </button>
  
    </div>
  </template>
  
  <script>
  // En una aplicación real, importarías axios o similar aquí
import axios from 'axios';
  
  export default {
    name: 'IndependentFileUpload',
    props: {
      // Tipos de archivo aceptados (formato de atributo 'accept')
      accept: {
        type: String,
        default: '*', // Acepta cualquier archivo por defecto
      },
      // Texto principal de la zona de drop
      dropZoneText: {
        type: String,
        default: 'Arrastra y suelta tu archivo aquí',
      },
      // URL del endpoint de carga (para el ejemplo real con axios)
      uploadUrl: {
        type: String,
        required: false // No requerido para la simulación
      }
    },
    data() {
      return {
        selectedFile: null,    // El objeto File seleccionado
        successFileName: '',   // Guardar el nombre para mostrarlo después de limpiar selectedFile
        isDragging: false,     // Si un archivo está siendo arrastrado sobre la zona
        isUploading: false,    // Si la carga está en progreso
        uploadError: null,     // Mensaje de error
        uploadedFileName: null,  // ID del archivo subido (simulado)
        uploadedFilePath: null,  // Ruta del archivo subido (simulado)
        uploadedFileId: null,  // ID del archivo subido (simulado)
      };
    },
    methods: {
      /**
       * Activa el clic en el input de archivo oculto.
       */
      triggerFileInput() {
        // Solo permite activar si no está subiendo o ya subido
        if (!this.isUploading && !this.uploadedFileName) {
          this.$refs.fileInput.click();
        }
      },
  
      /**
       * Maneja la selección de archivo desde el input.
       * @param {Event} event - El evento change del input.
       */
    //   handleFileChange(event) {


    //     console.log('Archivo seleccionado:', event.target.files);


    //     const files = event.target.files;
    //     if (files && files.length > 0) {
    //       this.resetState(false); // Limpia estado previo pero no el input
    //       this.selectedFile = files[0];
    //       this.uploadFile();
    //     }
    //     // Limpiar el valor del input para permitir seleccionar el mismo archivo de nuevo
    //     this.$nextTick(() => {
    //       if (targetInput) {
    //         targetInput.value = null;
    //       }
    //     });
    //   },


      /**
     * Handles file selection from the input.
     * @param {Event} event - The input's change event.
     */
    handleFileChange(event) {
      const files = event.target.files;
      const targetInput = event.target; // Store reference to the input

      if (files && files.length > 0) {
        const file = files[0];

        // Basic validation before proceeding
        if (this.accept !== '*' && !this.isValidFileType(file)) {
             this.uploadError = `Tipo de archivo no permitido. Solo se aceptan: ${this.accept}`;
             this.$emit('upload-error', { error: this.uploadError });
             // Clear the input value here as well in case of validation error
             targetInput.value = null;
             return;
         }

        this.resetState(false); // Clear previous state but not the input yet
        this.selectedFile = file;
        this.uploadFile(); // Start the upload process
      }

      // **MODIFICATION:** Clear the input value in the next tick
      // This often helps with cross-browser compatibility, especially Chrome.
      this.$nextTick(() => {
          if (targetInput) {
            targetInput.value = null;
          }
      });
    },
  
      /**
       * Maneja el evento dragover.
       */
      handleDragOver() {
         if (!this.isUploading && !this.uploadedFileName) {
           this.isDragging = true;
         }
      },
  
      /**
       * Maneja el evento dragleave.
       */
      handleDragLeave() {
        this.isDragging = false;
      },
  
      /**
       * Maneja el evento drop.
       * @param {DragEvent} event - El evento drop.
       */
      handleDrop(event) {
        if (this.isUploading || this.uploadedFileName) return; // No hacer nada si está ocupado
  
        this.isDragging = false;
        const files = event.dataTransfer.files;
        if (files && files.length > 0) {
           // Validar tipo de archivo si es necesario (comparar con this.accept)
           const file = files[0];
           if (this.accept !== '*' && !this.isValidFileType(file)) {
               this.uploadError = `Tipo de archivo no permitido. Solo se aceptan: ${this.accept}`;
               this.$emit('upload-error', { error: this.uploadError });
               return;
           }
  
          this.resetState(false); // Limpia estado previo
          this.selectedFile = file;
          this.uploadFile();
        }
      },
  
      /**
       * Valida si el tipo de archivo coincide con la prop 'accept'.
       * @param {File} file - El archivo a validar.
       * @returns {boolean} - True si el tipo es válido.
       */
      isValidFileType(file) {
          if (!this.accept || this.accept === '*') {
              return true;
          }
          const acceptedTypes = this.accept.split(',').map(t => t.trim().toLowerCase());
          const fileType = file.type.toLowerCase();
          const fileExtension = '.' + file.name.split('.').pop().toLowerCase();
  
          return acceptedTypes.some(type => {
              if (type.startsWith('.')) { // Es una extensión (ej: .pdf)
                  return fileExtension === type;
              }
              if (type.endsWith('/*')) { // Es un tipo base (ej: image/*)
                  return fileType.startsWith(type.slice(0, -1));
              }
              return fileType === type; // Es un tipo MIME completo (ej: image/jpeg)
          });
      },
  
   
      async uploadFile() {
        if (!this.selectedFile) return;
  
        this.isUploading = true;
        this.uploadError = null;
        this.uploadedFileId = null;
        const fileNameForSuccess = this.selectedFile.name; // Guardar antes de limpiar
        console.log(`Iniciando carga simulada de: ${this.selectedFile.name}`);
  
        
         if (!this.uploadUrl) { 
             console.error("Prop 'uploadUrl' es requerida para la carga real.");
             this.uploadError = "Configuración incompleta (falta URL de carga).";
             this.isUploading = false;
             this.$emit('upload-error', { error: this.uploadError });
             return;
         }
         const formData = new FormData();
         formData.append('file', this.selectedFile); // 'file' suele ser el nombre esperado
  
         try {
             const response = await axios.post(this.uploadUrl, formData, {
                 headers: { 'Content-Type': 'multipart/form-data' }
                 // Opcional: onUploadProgress para feedback real
             });
             console.log('Respuesta del servidor:', response.data);
             if (response.data && response.data.file_name) {
                 this.uploadedFileName = response.data.file_name;
                 this.uploadedFilePath = response.data.file_path;
                 this.uploadedFileType = response.data.file_type;
                 this.successFileName = fileNameForSuccess;
                 this.$emit('upload-success', { uploadedFileName: this.uploadedFileName,  uploadedFilePath: this.uploadedFilePath, uploadedFileType: this.uploadedFileType });
                 this.selectedFile = null; // Limpiar archivo
             } else {
                 throw new Error('Respuesta inválida del servidor');
             }
         } catch (error) {
             console.error('Error real al subir archivo:', error.response || error);
             const errorMessage = error.message || 'Error al subir el archivo.';
             this.uploadError = errorMessage;
             this.$emit('upload-error', { error: errorMessage });
             this.selectedFile = null; // Limpiar archivo
         } finally {
             this.isUploading = false;
         }
    
        
      },
  
      /**
       * Resetea el estado del componente.
       * @param {boolean} emitEvent - Si se debe emitir un evento 'reset'. Por defecto false.
       */
      resetState(emitEvent = false) {
        this.selectedFile = null;
        this.isDragging = false;
        this.isUploading = false;
        this.uploadError = null;
        this.uploadedFileName = null;
        this.uploadedFilePath = null;
        this.uploadedFileId = null;
        this.uploadedFileType = null;
        this.successFileName = '';
        // Asegurarse de que el input oculto también se limpie si es necesario
        if (this.$refs.fileInput) {
            this.$refs.fileInput.value = null;
        }
        if (emitEvent) {
            this.$emit('reset');
        }
        console.log('Estado reseteado');
      },
  
      /**
       * Formatea el tamaño del archivo a un formato legible.
       * @param {number} bytes - Tamaño en bytes.
       * @returns {string} - Tamaño formateado (KB, MB, etc.).
       */
       formatFileSize(bytes) {
          if (bytes === 0) return '0 Bytes';
          const k = 1024;
          const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
          const i = Math.floor(Math.log(bytes) / Math.log(k));
          return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
       }
    },
  };
  </script>
  
  <style scoped>
  .independent-file-uploader {
    font-family: sans-serif;
    width: 100%;
    max-width: 500px; /* O el ancho que prefieras */
    margin: 1em auto;
    position: relative; /* Para posicionar el botón reset */
  }
  
  .drop-zone {
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 30px;
    text-align: center;
    cursor: pointer;
    background-color: #f9f9f9;
    transition: background-color 0.2s ease, border-color 0.2s ease;
    position: relative;
    min-height: 150px; /* Asegura una altura mínima */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden; /* Para contener mensajes */
  }
  
  .drop-zone:hover {
    border-color: #999;
    background-color: #f1f1f1;
  }
  
  .drop-zone.is-dragging {
    border-color: #3498db;
    background-color: #eaf5fc;
  }
  
  .drop-zone.has-file,
  .drop-zone.has-error {
    border-style: solid; /* Cambia a sólido cuando hay archivo o error */
    cursor: default; /* No parece un botón si ya hay algo */
  }
  .drop-zone.has-file:not(.has-error) {
     border-color: #2ecc71; /* Verde para éxito o archivo listo */
     background-color: #f0fff4;
  }
  .drop-zone.has-error {
     border-color: #e74c3c; /* Rojo para error */
     background-color: #fff1f0;
  }
  
  /* Deshabilitar hover y click visualmente cuando está subiendo o listo */
  .drop-zone[aria-disabled="true"] {
      cursor: not-allowed;
      opacity: 0.7;
  }
  .drop-zone[aria-disabled="true"]:hover {
      border-color: #ccc; /* Evita cambio de color en hover */
      background-color: #f9f9f9; /* Evita cambio de color en hover */
  }
  .drop-zone[aria-disabled="true"].has-file:not(.has-error):hover {
      border-color: #2ecc71;
      background-color: #f0fff4;
  }
  
  
  .drop-zone-instructions {
    color: #555;
  }
  .drop-zone-instructions svg {
    margin-bottom: 10px;
    color: #999;
  }
  .drop-zone-instructions p {
    margin: 0 0 5px 0;
    font-size: 1.1em;
    font-weight: bold;
  }
  .drop-zone-instructions .browse-link {
    color: #3498db;
    text-decoration: underline;
    font-size: 0.9em;
  }
  
  .status-message {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px;
    width: 100%;
  }
  .status-message svg {
    margin-bottom: 10px;
    width: 30px;
    height: 30px;
  }
  .status-message p {
    margin: 0 0 5px 0;
    font-weight: bold;
  }
  .status-message small {
    font-size: 0.85em;
    color: #666;
    word-break: break-all; /* Para IDs largos */
  }
  .status-message strong {
      font-size: 0.9em;
      color: #333;
      margin-top: 5px;
      word-break: break-all;
  }
  
  .success-message svg { color: #2ecc71; }
  .success-message p { color: #27ae60; }
  
  .error-message svg { color: #e74c3c; }
  .error-message p { color: #c0392b; }
  .error-message small { color: #c0392b; }
  
  .uploading-message .spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-left-color: #3498db;
    animation: spin 1s ease infinite;
    margin-bottom: 15px;
  }
  .uploading-message p {
    color: #2980b9;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  .reset-button {
    display: inline-flex; /* Para alinear icono y texto */
    align-items: center;
    background-color: #e74c3c;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 6px 12px;
    cursor: pointer;
    font-size: 0.9em;
    margin-top: 10px;
    transition: background-color 0.2s ease;
    position: absolute; /* Posiciona relativo al contenedor */
    top: 10px;
    right: 10px;
  }
  .reset-button svg {
    margin-right: 5px;
  }
  
  .reset-button:hover {
    background-color: #c0392b;
  }
  .reset-button:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
  
  </style>
  